import React from 'react';

import Tabs, { Tab, TabList, TabPanel } from '@atlaskit/tabs';

import { useChild } from '../../hooks/useChildren.tsx';
import { useDynamicString } from '../../hooks/useDynamicValue.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UITabsProps } from '../../types/A2UIComponents.types.tsx';

type TabHeaderProps = {
	title: import('../../types/A2UICommon.types.tsx').DynamicString;
};

const TabHeader = ({ title }: TabHeaderProps) => {
	const text = useDynamicString(title);
	return <Tab>{text}</Tab>;
};

type TabContentProps = {
	childId: string;
	visited?: Set<string>;
};

const TabContent = ({ childId, visited }: TabContentProps) => {
	const child = useChild(childId, visited);
	return <TabPanel>{child}</TabPanel>;
};

type Props = {
	definition: A2UIComponentDefinition;
	visited?: Set<string>;
};

export const A2UITabs = ({ definition, visited }: Props): React.JSX.Element => {
	const def = definition as A2UITabsProps;

	return (
		<Tabs id={`a2ui-tabs-${def.id}`}>
			<TabList>
				{def.tabs.map((tab, index) => (
					<TabHeader key={index} title={tab.title} />
				))}
			</TabList>
			{def.tabs.map((tab, index) => (
				<TabContent key={index} childId={tab.child} visited={visited} />
			))}
		</Tabs>
	);
};
